import { GraphqlAPI } from "../../core/graphql-api";
import { setUserProperties } from "../../plugins/googleAnalytics";
import { setApplicationState } from "../../store/applicationState";
const graphqlServer = import.meta.env.VITE_GRAPHQL_SERVER_V1;
export default class ProfileService {
  constructor() {
    this.accessToken = localStorage.getItem("accessToken");
    this.graphqlAPIService = new GraphqlAPI(graphqlServer, this.accessToken);
    this.getMyProfile = this.getMyProfile.bind(this);
  }

  async getMyProfile() {
    try {
      const {
        userProfile: { name, email, profilePictureUrl: profilePicture, profileStatus,isProfileComplete = true, isB2BUser = false },
      } = await this.graphqlAPIService.getMyProfile();
      setApplicationState.setProfileDataLoadingStatus(true);
      localStorage.setItem("name", name);
      localStorage.setItem("email", email);
      if (!isB2BUser && !isProfileComplete) {
        setApplicationState.setProfileUpdateStatus(true);
      }
      localStorage.setItem("profilePicture", profilePicture);
      setApplicationState.setProfileDataLoadingStatus(false);
      const isQaAutomation = email.includes("qa-");
      setUserProperties(
        {
          account_type: isB2BUser ? "enterprise" : "consumer",
          qa_automation: isQaAutomation,
          platform: "web",
          os_version: navigator.userAgent,
          device_class: "desktop",
          region: navigator.language,
        }
      )

      return { email, name, profilePicture, profileStatus};
    } catch (error) {
      console.log({error});
      if(error?.name ==="UNAUTHORIZED"){
       return {status:401}
      }
      // throw error;
      // return {
      //   email: "guest@gmail.com",
      //   userName: "guest",
      //   profilePicture: "GU",
      // };
    }
  }

  async updateUserProfile({email, name}) {
    const input = {
      email,
      name
    };

    try {
      const { updateUserProfile } =
        await this.graphqlAPIService.updateUserProfile_v4(input);
      const updatedName = updateUserProfile.profile.name;
      localStorage.setItem("name", updatedName);
    } catch (error) {
      console.error("Error updating profile:", error);
      throw error;
    }
  }

  async getSubscriptionData() {
    // call the API
  }

  async deleteAccount() {
    try {
      const response = await this.graphqlAPIService.deleteAccount();
      return response;
    } catch (error) {
      console.error('Error deleting account:', error);
      throw error;
    }
  }
}
